module.exports = __webpack_public_path__ + "media/assets/dashboard/insight-b28520c3bcf4769978819db143c99f01.png";